import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '@jetbrains/ring-ui/components/icon/icon';
import Text from '@jetbrains/ring-ui/components/text/text';
import cloudOffIcon from '@app/assets/cloud-off.svg';
import styles from './offline-mode-banner.css';
export function OfflineModeBanner() {
    return (_jsxs(Text, { info: true, className: styles.banner, title: "Offline Mode", children: [_jsx(Icon, { glyph: cloudOffIcon, className: styles.icon }), _jsx("span", { className: styles.bannerText, children: "Offline Mode" })] }));
}
